<template>
  <div class="product-filter-bar border-bottom pb-3">
    <div class="d-flex">
      <el-input v-model="filter.term" prefix-icon="el-icon-search" :placeholder="$t('placeholder.productfilterbar')" />
      <span v-b-toggle.advanced-filter-collapse class="filter-button el-link ml-2">Filter</span>
    </div>
    <span v-if="isActiveFilter" class="small el-link el-link--primary p-3 mt-2 el-tag" @click="resetFilter">
      <i class="el-icon-close mt-1"></i>
      <span>{{ $t('general.reset_filter') }}</span>
    </span>
    <b-collapse id="advanced-filter-collapse">
      <el-divider />
      <div class="pt-3 pb-1 tags-grid text-left">
        <div>
          <div class="mb-2 d-flex w-100 justify-content-between">
            <span class="font-weight-bold">{{ $tc('products.productgroup', 2) }}</span>
            <el-switch
              v-model="filter.groups.type"
              style="display: block"
              active-color="#004571"
              inactive-color="#004571"
              :active-text="$t('general.and')"
              :inactive-text="$t('general.or')"
              active-value="and"
              inactive-value="or"
            >
            </el-switch>
          </div>
          <el-select
            ref="grSelect"
            v-model="filter.groups.items"
            class="w-100"
            multiple
            :popper-append-to-body="false"
            :placeholder="$t('placeholder.select_groups')"
          >
            <el-option v-for="item in groups" :key="item.id" :label="item.get('name')" :value="item.id" />
          </el-select>
        </div>
        <div>
          <div class="mb-2 d-flex w-100 justify-content-between">
            <span class="font-weight-bold">{{ $tc('products.productattribute', 2) }}</span>
            <el-switch
              v-model="filter.attributes.type"
              style="display: block"
              active-color="#004571"
              inactive-color="#004571"
              :active-text="$t('general.and')"
              :inactive-text="$t('general.or')"
              active-value="and"
              inactive-value="or"
            >
            </el-switch>
          </div>
          <el-select
            ref="attSelect"
            v-model="filter.attributes.items"
            class="w-100"
            multiple
            :popper-append-to-body="false"
            :placeholder="$t('placeholder.select_attributes')"
          >
            <el-option v-for="item in attributes" :key="item.id" :label="item.get('name')" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StoreModules from '../../../store/store-modules';
export default {
  name: 'ProductFilterBar',
  components: {},
  props: {},
  async created() {
    this.defaultFilter = _.cloneDeep(this.filter);
    this.applyFilterFromQuery();
    await this.loadAttributes();
    await this.loadGroups();
    document.addEventListener('scroll', this.scrolled, true);
  },
  destroyed() {
    document.removeEventListener('scroll', this.scrolled);
  },
  data() {
    return {
      filter: {
        term: '',
        attributes: {
          items: [],
          type: 'or',
        },
        groups: {
          items: [],
          type: 'or',
        },
      },
      defaultFilter: null,
      showFilter: false,
    };
  },
  computed: {
    ...mapGetters(StoreModules.PRODUCT_ATTRIBUTES, ['attributes']),
    ...mapGetters(StoreModules.PRODUCT_GROUPS, ['groups']),
    isActiveFilter() {
      return JSON.stringify(this.defaultFilter) !== JSON.stringify(this.filter);
    },
  },
  watch: {
    filter: {
      deep: true,
      handler(val) {
        if (this.isActiveFilter) this.emitSearchFilter();
        else this.$emit('reset');
      },
    },
  },
  methods: {
    ...mapActions(StoreModules.PRODUCT_ATTRIBUTES, ['loadAttributes']),
    ...mapActions(StoreModules.PRODUCT_GROUPS, ['loadGroups']),
    scrolled(e) {
      if (![...e.target.classList].includes('el-select-dropdown__wrap')) {
        if (this.$refs.attSelect) this.$refs.attSelect.handleClose();
        if (this.$refs.grSelect) this.$refs.grSelect.handleClose();
      }
    },
    emitSearchFilter() {
      this.$emit('search', this.getCleanedFilter());
    },
    resetFilter() {
      this.filter = _.cloneDeep(this.defaultFilter);
      this.$emit('reset');
    },
    getCleanedFilter() {
      let tmp = _.cloneDeep(this.filter);
      if (tmp.term === '') {
        delete tmp.term;
      }

      if (tmp.attributes.items.length === 0) {
        delete tmp.attributes;
      }

      if (tmp.groups.items.length === 0) {
        delete tmp.groups;
      }

      return tmp;
    },
    applyFilterFromQuery() {
      if (!this.$route.query.search) return;
      let queryFilter = JSON.parse(decodeURI(JSON.stringify(this.$route.query)));
      queryFilter = JSON.parse(queryFilter.search);

      if (queryFilter.term) {
        this.filter.term = queryFilter.term;
      }
      if (queryFilter.attributes) {
        this.filter.attributes = queryFilter.attributes;
      }
      if (queryFilter.groups) {
        this.filter.groups = queryFilter.groups;
      }
      this.emitSearchFilter();
    },
  },
};
</script>

<style scoped>
.product-filter-bar {
  width: 100%;
}
.filter-button {
  letter-spacing: 0px;
  font-weight: bold;
  font-size: 1rem;
}

.tags-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
}

@media only screen and (max-width: 600px) {
  .tags-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
